export const trackingDayBaseOptions = [
  { label: 'Day -1', value: -1 },
  { label: 'Day 0', value: 0 },
  { label: 'Day 1', value: 1 },
];
